import React from 'react';
import { Link } from 'react-router-dom';
import { formationsInternes } from '../data/mockData';
import { Flame, Heart, Shield, AlertTriangle } from 'lucide-react';

const iconMap = {
  'ssiap': Flame,
  'incendie-interne': Flame,
  'secourisme-interne': Heart,
  'securite-privee-interne': Shield
};

const FormationsInternes = () => {
  return (
    <div>
      {/* Hero Section */}
      <div 
        className="relative h-[400px] flex items-center justify-center text-white"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1622115585848-1d5b6e8af4e4?w=1920&h=400&fit=crop)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/70 to-black/80"></div>
        
        <div className="relative z-10 container mx-auto px-4 text-center">
          <div className="mb-4 text-sm">
            <Link to="/" className="text-gray-300 hover:text-white">Accueil</Link>
            <span className="mx-2 text-red-500">/</span>
            <span className="text-red-500">Formations internes</span>
          </div>
          
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 uppercase tracking-wide">
            Formations internes
          </h1>
          
          <p className="text-lg md:text-xl text-gray-200 max-w-3xl mx-auto">
            Sessions inter-entreprises dans nos centres de formation certifiés
          </p>
        </div>
      </div>

      {/* Info Section */}
      <section className="py-12 bg-white border-b">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
              Sessions planifiées dans nos centres
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-6">
              Retrouvez nos formations diplom antes et certifiantes. Financement CPF disponible pour la plupart des formations.
            </p>
            <Link 
              to="/calendrier"
              className="inline-block bg-red-600 text-white px-6 py-3 rounded-md hover:bg-red-700 transition-colors font-semibold"
            >
              CONSULTER LE CALENDRIER DES SESSIONS
            </Link>
          </div>
        </div>
      </section>

      {/* Formations Grid */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {formationsInternes.map((category) => {
              const Icon = iconMap[category.slug] || Shield;
              return (
                <Link
                  key={category.id}
                  to={`/formations/${category.slug}`}
                  className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
                >
                  <div className="relative h-80 overflow-hidden">
                    <img 
                      src={`${category.image}?w=600&h=800&fit=crop`}
                      alt={category.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
                    
                    <div className="absolute top-0 left-0 right-0 h-1 bg-red-600"></div>
                    
                    <div className="absolute top-6 left-6 bg-white rounded-full p-4 shadow-lg group-hover:bg-red-600 transition-colors duration-300">
                      <Icon size={32} className="text-red-600 group-hover:text-white transition-colors duration-300" />
                    </div>
                  </div>

                  <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                    <h3 className="text-2xl font-bold mb-2 uppercase tracking-wide">
                      {category.title}
                    </h3>
                    <p className="text-gray-200 text-sm mb-4">
                      {category.formationsCount} formation{category.formationsCount > 1 ? 's' : ''}
                    </p>
                    <div className="border-2 border-white px-5 py-2 rounded-md inline-block group-hover:bg-white group-hover:text-red-600 transition-all duration-300 font-semibold">
                      VOIR LES FORMATIONS
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default FormationsInternes;